module.exports = __webpack_public_path__ + "static/media/landing-bg.df8fd3ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing-bg.jpg
// module id = 101
// module chunks = 0